import { IconBranchFill } from '@saucelabs/ds-icons';
import { Typography } from '@saucelabs/ds-typography';
import PlatformIcon from '@saucelabs/sl-component-platform-icon';
import React from 'react';

import { useFragment } from '../../graphql/__generated__';
import { DiffViewFragmentFragment } from '../../graphql/__generated__/graphql';
import { formatDate, TimeMode } from '../common/DateLabel';
import Truncate from '../common/Truncate';
import { DiffViewSnapshotFragment } from './DiffView';

type Props = {
  diffView: DiffViewFragmentFragment;
  project?: string;
}

const DiffHeaderInfo: React.FC<Props> = ({ diffView, project }) => {
  const snapshot = useFragment(DiffViewSnapshotFragment, diffView.snapshot)!;

  return (
    <div className="min-w-0">
      <div className="flex mt-1.5 mb-0.5">
        {project && (
          <Typography
            className="text-medium-emphasis mr-1"
            disableSpacing
            variant="heading-5"
          >
            {project}
          </Typography>
        )}
        <Typography
          className="text-high-emphasis "
          disableSpacing
          variant="heading-5"
        >
          {snapshot.name}
        </Typography>
      </div>
      <div className="flex mb-2 mr-2 text-medium-emphasis whitespace-nowrap">
        {snapshot.browser && (
          <div className="flex gap-1 items-center mr-1">
            <PlatformIcon
              className="fill-current"
              name={snapshot.browser}
            />
            <Typography
              className="flex items-center"
              disableSpacing
              variant="body"
            >
              {snapshot.browserVersion}
            </Typography>
          </div>
        )}
        {snapshot.operatingSystem && (
          <div className="flex gap-1 items-center">
            <PlatformIcon
              className="fill-current"
              name={snapshot.operatingSystem}
            />
            <Typography
              className="flex items-center"
              disableSpacing
              variant="body"
            >
              {snapshot.operatingSystemVersion}
            </Typography>
          </div>
        )}
        {snapshot.device && (
          <div className="flex gap-1 items-center mr-1">
            <Typography
              className="ml-1 flex items-center"
              disableSpacing
              variant="body"
            >
              {snapshot.device}
            </Typography>
          </div>
        )}
        {(snapshot.browser || snapshot.operatingSystem) && <span className="text-base mx-1">|</span>}
        {snapshot.viewportHeight && snapshot.viewportWidth && (
          <>
            <div className="flex gap-1 items-center">
              <Typography
                className="flex items-center"
                disableSpacing
                variant="body"
              >
                {snapshot.viewportWidth}
                {' '}
                x
                {' '}
                {snapshot.viewportHeight}
              </Typography>
            </div>
            <span className="text-base mx-1">|</span>
          </>
        )}
        <Truncate
          className="min-w-8"
          text={`Taken at ${formatDate[TimeMode.DATE](diffView.createdAt)}`}
          variant="body"
        />
      </div>
    </div>
  );
};

export default DiffHeaderInfo;
